import React from "react";
import { Badge } from "./StatusBadge.styled";

interface StatusBadgeProps {
  status: string;
  label: string;
  width?: string | number;
}

/**
 * Reusable status badge component
 * Supports statuses:
 * - Treatment plan: "in-progress", "approved", "declined-by-patient"
 * - User: "active", "inactive", "invited", "suspended"
 * - Action: "success", "failure"
 */
const StatusBadge: React.FC<StatusBadgeProps> = ({ status, label, width }) => {
  return (
    <Badge status={status} width={width}>
      {label}
    </Badge>
  );
};

export default StatusBadge;
